'use strict';

import { baseInit, baseInitGpt, baseSetupHeroSkin } from './_base';

const classNames = {
	author: 'author',
	readMore: 'read-more',
	extendedBio: 'extended-bio'
};

const setReadMoreLink = () => {
	const $readMoreLink = $.findByBem(classNames.author, classNames.readMore);
	const $extendedBio = $.findByBem(classNames.author, classNames.extendedBio);
	$readMoreLink.on('click.showAuthorBio', () => {
		$readMoreLink.hide();
		$extendedBio.fadeIn();
	});
};

export function init() {
	baseInit();
	setReadMoreLink();
}

export function initGpt(adConfig) {
	baseInitGpt(adConfig);
}

export function setupHeroSkin(options) {
	baseSetupHeroSkin(options);
}